import React, { useMemo, useState } from "react";
import { SearchIcon, PlusIcon, CheckIcon } from "lucide-react";
import { ingredients } from "../../data/ingredients";
import { categories } from "../../data/categories";
import { useQuote } from "../../contexts/QuoteContext";
function normalize(s: string) {
  return s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}
export function IngredientFinder() {
  const [query, setQuery] = useState("");
  const {
    has,
    toggle,
    items,
    open
  } = useQuote();
  const results = useMemo(() => {
    const q = normalize(query.trim());
    if (!q) return ingredients.slice(0, 4);
    return ingredients.filter(i => normalize(`${i.name} ${i.inci}`).includes(q)).slice(0, 4);
  }, [query]);
  const categoryName = (id: string) => categories.find(c => c.id === id)?.name ?? "";
  return <div className="rounded-2xl bg-paper p-5 shadow-[0_24px_60px_-20px_rgba(27,33,25,0.45)] md:p-6" data-id="element-155" data-mp="2jo7pohku945j">
      <label htmlFor="finder" className="text-sm font-medium text-ink" data-id="element-156" data-mp="2oi27ffgvv91z">
        Trouver un ingrédient
      </label>
      <div className="relative mt-3" data-id="element-157" data-mp="1lre4euh5rlz8">
        <SearchIcon className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-stone" aria-hidden data-id="element-158" data-mp="1hsf0nd75xv9d" />
        <input id="finder" type="search" value={query} onChange={e => setQuery(e.target.value)} placeholder="Nom ou INCI — ex. lavande, Rosmarinus…" className="h-12 w-full rounded-full border border-line bg-white pl-11 pr-4 text-sm text-ink placeholder:text-stone/80 focus:border-olive focus:outline-none focus:ring-2 focus:ring-olive/20" autoComplete="off" data-id="element-159" data-mp="1vk1znkshphvu" />
      </div>

      <p className="mt-5 text-xs text-stone" data-id="element-160" data-mp="29j1mcmwfzmpd">{query.trim() ? "Résultats" : "Les plus demandés ce mois-ci"}</p>
      <ul className="mt-2" aria-live="polite" data-id="element-161" data-mp="k3v3yxbe0c68">
        {results.length === 0 && <li className="py-6 text-sm leading-relaxed text-stone" data-id="element-162" data-mp="f51s19br0t86">
            Aucune référence ne correspond. Décrivez votre besoin dans la demande de devis, nous vous proposerons
            un équivalent ou une production sur-mesure.
          </li>}
        {results.map(ing => {
        const added = has(ing.id);
        return <li key={ing.id} className="flex items-center justify-between gap-3 border-b border-line py-3 last:border-0" data-id="element-163" data-mp="2p4o6x5bc2qr1">
              <div className="min-w-0" data-id="element-164" data-mp="2t4y9e7zx2z15">
                <p className="truncate text-sm font-medium text-ink" data-id="element-165" data-mp="2y6nlzs2sfkrc">{ing.name}</p>
                <p className="truncate text-xs text-stone" data-id="element-166" data-mp="3358nduts0ahd">
                  {categoryName(ing.category)} · <span className="italic" data-id="element-167" data-mp="332vzz25917wx">{ing.inci}</span>
                </p>
              </div>
              <button type="button" onClick={() => toggle({
            id: ing.id,
            name: ing.name,
            inci: ing.inci
          })} aria-pressed={added} aria-label={added ? `Retirer ${ing.name} de la sélection` : `Ajouter ${ing.name} à la sélection`} className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ease-out ${added ? "border-olive bg-olive text-paper" : "border-line text-ink hover:border-olive hover:bg-cream"}`} data-id="element-168" data-mp="37ybb3mbvgppn">
                {added ? <CheckIcon className="h-4 w-4" data-id="element-169" data-mp="119j9b584h5pk" /> : <PlusIcon className="h-4 w-4" data-id="element-170" data-mp="w9dg3km7fb5d" />}
              </button>
            </li>;
      })}
      </ul>

      {items.length > 0 && <button type="button" onClick={open} className="mt-4 h-11 w-full rounded-full bg-ink text-sm font-medium text-paper transition-colors duration-150 ease-out hover:bg-olive" data-id="element-171" data-mp="1t0yucuu16kdo">
          Voir ma sélection ({items.length})
        </button>}
    </div>;
}